import React from 'react';
import { TCIDropdown } from '@/components/ui/Dropdown';
import Icon from '@/components/ui/Icon';
import { ValidIcon } from '@/components/ui/Icon/Icon';
import Text from '@/components/ui/Text';
import cn from '@/utils/cn';

interface GradeFasterItemProps {
  description: string;
  disabled?: boolean;
  icon: ValidIcon;
  iconClassName?: string;
  openedWithPointer: boolean;
  title: React.ReactNode;
  onSelect: (event: Event) => void;
}

const GradeFasterItem = ({
  description, disabled = false, icon, iconClassName = 'tw-size-5', openedWithPointer, title, onSelect,
}: GradeFasterItemProps) => (
  <TCIDropdown.Item
    className={cn(
      'tw-mx-0 tw-items-start tw-gap-1.5 tw-px-2.5 tw-py-1.5 aria-disabled:tw-opacity-100',
      disabled ? 'tw-text-dark-grey' : 'tw-text-tci-black',
      // AIDEV-NOTE: TCIDropdown focuses the first item on open, which matches :focus-visible even after a
      // click. Keep the purple ring for keyboard opens only; mouse users get the sheet's grey hover.
      openedWithPointer && 'focus-visible:tw-ring-0 focus:tw-bg-transparent',
      openedWithPointer && !disabled && 'hover:!tw-bg-light-grey',
    )}
    disabled={disabled}
    onSelect={onSelect}
  >
    <span
      className={cn(
        'tw-flex tw-size-5 tw-shrink-0 tw-items-center tw-justify-center tw-mt-px',
        disabled ? 'tw-text-dark-grey' : 'tw-text-tci-purple',
      )}
    >
      <Icon className={iconClassName} icon={icon} />
    </span>
    <span className="tw-flex tw-flex-col">
      <Text className="tw-flex tw-items-center tw-gap-1" size="sm" tag="span" weight="semibold">
        {title}
      </Text>
      <Text className={cn({ '!tw-text-very-dark-grey': !disabled })} size="xs" tag="span">
        {description}
      </Text>
    </span>
  </TCIDropdown.Item>
);

export default GradeFasterItem;
